/** Needed for @i18n/next */
"use client";

import type { ReactElement } from "react";
import type { Formats, TranslationValues } from "use-intl";

import { I18nMessage as MessageAgnosticI18nMessage } from "../components/I18nMessage";
import type {
  LooseMessageKey,
  ScopedMessageKey,
} from "../types/appMessages.types";

export type I18nMessageProps<
  TMessage extends LooseMessageKey = LooseMessageKey,
> = {
  formats?: Partial<Formats>;
  message: TMessage & ScopedMessageKey<TMessage>;
  values?: TranslationValues;
};

/**
 * The same component `@i18n/react` exports, with its `message` prop narrowed to
 * the messages the app declared through `AppMessagesConfig`.
 */
export const I18nMessage = MessageAgnosticI18nMessage as <
  TMessage extends LooseMessageKey,
>(
  props: I18nMessageProps<TMessage>,
) => ReactElement;
